"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributionsTables = void 0;
const adContent_1 = require("./adContent");
const adTerm_1 = require("./adTerm");
const campaignName_1 = require("./campaignName");
const sourceMedium_1 = require("./sourceMedium");
exports.attributionsTables = {
    adContentTable: {
        name: 'Ad content',
        query: adContent_1.adContentTable,
    },
    adTermTable: {
        name: 'Ad term',
        query: adTerm_1.adTermTable,
    },
    campaignNameTable: {
        name: 'Campaign name',
        query: campaignName_1.campaignNameTable,
    },
    sourceMediumTable: {
        name: 'Source / Medium',
        query: sourceMedium_1.sourceMediumTable,
    },
};
//# sourceMappingURL=index.js.map